'use client';

import { Link } from '@coolblue-development/freddy';
import selectAllTrigger from '@coolblue-development/ga4-events/triggers/AccessoryEntrances/selectAllTrigger';
import { ArrowRight } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';

type Props = {
  href: string;
  children?: React.ReactNode;
};

export default function ViewAllAccessoriesLink({ href, children }: Props) {
  const { trackEvent } = useAnalytics();

  function onClick() {
    trackEvent(
      selectAllTrigger({
        content: 'all_accessories',
        sub_feature: 'below_element'
      })
    );
  }

  return (
    <Link onClick={onClick} startIcon={<ArrowRight />} mt={400} href={href} rel='nofollow'>
      {children}
    </Link>
  );
}
